import { useLocation } from "react-router-dom"
import { BtnBack, BtnPrimary } from "../../components/buttons"
import TablePageOne from "../adminManagement/tablePageOne"



const ShowFollowers = (props)=>{
  const {state} = useLocation()

    return(
	<>
	 <BtnBack/>
	<TablePageOne key='followers'
    pageTitle={'User Followers'}
    apiGETLink={`${process.env.REACT_APP_API_LINK}/user/getUserFollowers`}
    apiBODY = {state.apiBODY}
    // apiPOSTLink={`${process.env.REACT_APP_API_LINK}/admin/addSubscription`}
    dBFields={[
      {name:'Email id',value:"email"},
      {name:'User name',value:"fullname"},
      {name:'Mobile number',value:"mobileno"},
      
    ]}
    formLink={"/form"}
    showAction={false}
    showAddBtn={false}

/>
</>
)
}

export default ShowFollowers